import { Container } from 'react-bootstrap';

const FoodSafetyPolicy = () => {
  return (
    <section className="food-safety-policy py-5">
      <Container>
        <div className="mt-5 mb-4">
          <h4 className="text-uppercase mb-4 text-center">FOOD SAFETY POLICY</h4>
          
          <div className="policy-content">
            <p>
              Easy Sauces Nigeria Limited, manufacturing, is committed legally, morally &amp; socially to the manufacturing Sales and Marketing of ready to use tomato-pepper sauce under safe, healthy and environmental friendly work place, plant and machineries according to internationally accepted standards of good manufacturing practices.
            </p>
            
            <p>
              Easy Sauces ensures that materials produced are of the highest standards complying with all relevant legislation and approved code of practice. We will regularly measure the compliance and implement the performance objectives by producing food which are safe for consumption, while meeting their food safety expectations.
            </p>
            
            <p className="mb-3">The Food Safety Policy objectives shall be achieved by:</p>
            <ul className="policy-objectives">
              <li>establishing, implementing and maintaining a food safety policy that is appropriate to the purpose and context of the organization;</li>
              <li>providing a framework for setting and reviewing the objectives of the FSMS;</li>
              <li>Conforming to statutory and regulatory requirements and to mutually agreed food safety requirements of the customers.</li>
              <li>Adequately addressing Internal and External Communication and, implementing and maintaining the principles at all levels of the organization.</li>
              <li>Showing commitment to continual improvement of the FSMS</li>
              <li>Addressing the need to ensure competencies related to food safety.</li>
              <li>Ensuring that the policy is supported by measurable objectives which are reviewed periodically for continued suitability.</li>
            </ul>
            
            <p>
              The top management will ensure the best usage of both human and financial resources towards implementing the FOOD SAFETY POLICY across all our operations and the same are properly communicated to every one for strict adherence.
            </p>
            
            <p>
              Our Food Safety performance will be considered at every management meeting and the top management will review this policy annually to ensure that it continues to reflect the aims and aspirations of the company.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FoodSafetyPolicy;

